"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("../../_virtual/_rollupPluginBabelHelpers.js"),r=require("../jewlr/theme.js"),l=e.objectSpread2({},r.default);exports.default=l;
//# sourceMappingURL=theme.js.map
